import { createContext, useContext, useState } from 'react';

export const SIZE_PRESETS = [
  { key: 'low',    label: 'Small',  scale: 1     },
  { key: 'medium', label: 'Medium', scale: 1.12  },
  { key: 'high',   label: 'Large',  scale: 1.25  },
];

const MOBILE_BREAKPOINT = 768;

const SizeContext = createContext(null);

export function SizeProvider({ children }) {
  const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

  const [sizeKey, setSizeKey] = useState(
    () => localStorage.getItem('prvsk_size_v1') || 'high'
  );

  const preset = SIZE_PRESETS.find(p => p.key === sizeKey) || SIZE_PRESETS[2];
  const scale  = isMobile() ? 1 : preset.scale;

  const switchSize = (key) => {
    setSizeKey(key);
    localStorage.setItem('prvsk_size_v1', key);
  };

  return (
    <SizeContext.Provider value={{ sizeKey, scale, sizes: SIZE_PRESETS, switchSize }}>
      {children}
    </SizeContext.Provider>
  );
}

export const useSize = () => useContext(SizeContext);
